module.exports = __webpack_public_path__ + "static/media/placeholder_fr.03dae1a7.jpg";